/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Transcript_Export_Duration_ValueInputs */

const en_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
};

const fr_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration} s)`)
};

const de_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
};

const it_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}sec)`)
};

const ru_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}сек)`)
};

const es_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}seg)`)
};

const zh_cn2_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.duration}秒）`)
};

const ja_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}秒)`)
};

const hi_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}सेकंड)`)
};

const pt_pt2_transcript_export_duration_value = /** @type {(inputs: Transcript_Export_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.duration}seg)`)
};

/**
* | output |
* | --- |
* | "({duration}sec)" |
*
* @param {Transcript_Export_Duration_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_value = /** @type {((inputs: Transcript_Export_Duration_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_duration_value(inputs)
	if (locale === "de") return de_transcript_export_duration_value(inputs)
	if (locale === "it") return it_transcript_export_duration_value(inputs)
	if (locale === "ru") return ru_transcript_export_duration_value(inputs)
	if (locale === "es") return es_transcript_export_duration_value(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_duration_value(inputs)
	if (locale === "ja") return ja_transcript_export_duration_value(inputs)
	if (locale === "hi") return hi_transcript_export_duration_value(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_duration_value(inputs)
	return en_transcript_export_duration_value(inputs)
});